import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { Counter, DEFAULT_MAX_COUNT } from '../../../Counter'
import { FloatingTooltip } from '../../../Floating'
import { TableCellBase, TableCellText, TableEmptyCell } from '../../../Table'

import { QA_NAME_LISTING_APPLICANTS_NEW } from './RentalPortalListingsApplicantsCell.constants'

import * as styles from './RentalPortalListingsApplicantsCell.module.css'

function RentalPortalListingsApplicantsCell({ count, newCount, ...cellProps }) {
  const { t } = useTranslation()

  return count > 0 ? (
    <TableCellBase
      {...cellProps}
      className={styles.RentalPortalListingsApplicantsCell}
    >
      <TableCellText value={String(count)} />
      <FloatingTooltip
        content={t('RentalPortal.ListingNewApplicantsTooltipKey', {
          count: newCount,
        })}
        disabled={!newCount}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <span className={styles.counter}>
          <Counter
            fixed
            count={Math.min(newCount, DEFAULT_MAX_COUNT)}
            qaName={QA_NAME_LISTING_APPLICANTS_NEW}
          />
        </span>
      </FloatingTooltip>
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default RentalPortalListingsApplicantsCell
